var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-485.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(485.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "to-fill",
    id: "Rectangle",
    fill: "#220BAB",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    className: "to-color",
    id: "Group-2",
    transform: "translate(135.000000, 82.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "126.872247 36.123348 163.876652 0 126.872247 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "163.380617 36.4828194 126.872247 72.8784141 126.872247 109.251101 163.380617 109.251101 163.380617 72.8784141 200 36.4828194 200 0 163.380617 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "200 73.1277533 162.995595 109.251101 200 109.251101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 102.607048 73.4731278 102.607048 73.4731278 139.207048 110.132159 139.207048 110.132159 73.0669604 36.7920705 73.0669604 110.132159 0 73.4731278 0 0 73.0669604"
  })), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-graduated-from-\\xC9co",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 36,
    fontWeight: "bold",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 134,
    y: 293
  }, "I graduated"), /*#__PURE__*/React.createElement("tspan", {
    x: 134,
    y: 342
  }, "from"), /*#__PURE__*/React.createElement("tspan", {
    x: 134,
    y: 391
  }, "\xC9cole 42")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.d93e7bca2671e4883bce11351640d9ab.svg";
export { ForwardRef as ReactComponent };